import {ClientBookmark} from "../../domain/model/client_bookmark";
import {Customer} from "../../domain/model/customer";
import {TJobCareerWithCustomerID} from "../../domain/repository/job_career_repository";

interface IGetAllClientBookMarkByClientResponse {
    clientBookmarks?: ClientBookmark[];
    customers?: Customer[];
    jobCareersWithCustomerID?: TJobCareerWithCustomerID[];

}
class GetAllClientBookMarkByClientResponse implements IGetAllClientBookMarkByClientResponse {
    public clientBookmarks: ClientBookmark[];
    public customers: Customer[];
    public jobCareersWithCustomerID: TJobCareerWithCustomerID[];
}

export {
    GetAllClientBookMarkByClientResponse
}


// WEBPACK FOOTER //
// ./src/presentation/response/client_bookmark_response.ts